export default "__VITE_ASSET__CgQR5VVT__"